import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, Table, Button, HelpBlock, Glyphicon, Alert, Badge } from 'react-bootstrap';
import { Checkbox, RadioGroup, Radio } from 'react-icheck';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import GradeDetailsLink from '../../common/components/GradeDetailsLink';
import TeacherDetailsLink from '../../common/components/TeacherDetailsLink';
import FontAwesome from 'react-fontawesome';
import { withNamespaces, Trans } from 'react-i18next';
import moment from 'moment';
import ReduxBlockUi from 'react-block-ui/redux';
import Dialog from '../../common/components/Dialog';
import CheckoutComponent from './paymentMethods/CheckoutComponent';
import PromoCodes from './PromoCodes';
import analyticsTracker, { AnalyticsPlatforms } from '../../common/services/analyticsTracker';
import 'icheck/skins/minimal/grey.css';
import 'react-block-ui/style.css';
import { PaymentTypes } from '../payments/actions';
import utils from '../../common/services/utils';
import ui from '../../common/services/ui';
import { i18n } from '../../common/services/globalize';

class Confirm extends Component {
	constructor(props) {
		super(props);
		this.toggleTermsAndConditions = this.toggleTermsAndConditions.bind(this);
		this.showTermsAndConditions = this.showTermsAndConditions.bind(this);
		this.hideInfoDialog = this.hideInfoDialog.bind(this);
		this.handlePaymentMethodChange = this.handlePaymentMethodChange.bind(this);
		this.handleConfirmClick = this.handleConfirmClick.bind(this);
		this.state = {
			selectedInstalmentPlanTemplateId: null,
			agreeWithTermsAndConditions: false,
			agreeWithTermsAndConditionsValidation: false,
			showInfoDialog: false,
			infoMessage: '',
			infoTitle: ''
		};
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.payment && nextProps.payment) {
			const { paymentType, payment, franchisorCurrency } = nextProps;
			const { lesson, center, consultationType, workshop } = payment;
			const items = [];

			switch (paymentType) {
				case PaymentTypes.Lesson:
					if (lesson) {
						items.push({
							item_id: lesson.grade && lesson.grade.id,
							item_name: lesson.grade && lesson.grade.name,
							item_brand: lesson.center && lesson.center.name,
							item_category: lesson.term && `${lesson.term.name}, ${lesson.term.schoolYear}`,
							quantity: payment.quantity,
							price: payment.unitPriceAmount
						});
					}
					break;
				case PaymentTypes.IndividualConsultation:
					if (center && consultationType) {
						items.push({
							item_id: `Individual_Consultation_${consultationType}`,
							item_name: consultationType,
							item_brand: center.name,
							item_category: 'Individual_Consultation',
							quantity: payment.quantity,
							price: payment.unitPriceAmount
						});
					}
					break;
				case PaymentTypes.Workshop:
					if (center && workshop) {
						items.push({
							item_id: `Workshop_${workshop.id}`,
							item_name: workshop.name,
							item_brand: center.name,
							item_category: 'Workshop',
							quantity: payment.quantity,
							price: payment.unitPriceAmount
						});
					}
					break;
			}

			analyticsTracker.trackEvent('begin_checkout', {
				value: payment.totalAmount,
				currency: franchisorCurrency,
				items
			}, AnalyticsPlatforms.GoogleAnalytics);
		}
	}

	toggleTermsAndConditions() {
		this.setState({
			agreeWithTermsAndConditions: !this.state.agreeWithTermsAndConditions
		});
	}

	showTermsAndConditions() {
		const { termsAndConditions, t } = this.props;
		this.setState({
			showInfoDialog: true,
			infoMessage: termsAndConditions,
			infoTitle: t('FO_Register_TermsAndConditionsTitle')
		});
	}

	hideInfoDialog() {
		this.setState({
			showInfoDialog: false
		});
	}

	handlePaymentMethodChange(event) {
		const selectedPaymentOptionParts = event.target.value.split(':');
		if (selectedPaymentOptionParts.length === 3) {
			const paymentMethodName = selectedPaymentOptionParts[0];
			const isInstalmentPayment = selectedPaymentOptionParts[1] === '1' ? true : false;
			const instalmentPlanTemplateId = selectedPaymentOptionParts[2];

			const selectedPaymentMethod = paymentMethodName ? this.props.paymentMethods.find(x => x.name === paymentMethodName) : null;
			if (selectedPaymentMethod && this.props.onSelectPaymentMethod) {
				this.props.onSelectPaymentMethod(selectedPaymentMethod, isInstalmentPayment, instalmentPlanTemplateId);
			}
			this.setState({ selectedInstalmentPlanTemplateId: instalmentPlanTemplateId });
		}
	}

	handleConfirmClick() {
		if (this.props.requireConsentOnPayment && !this.state.agreeWithTermsAndConditions) {
			this.setState({
				agreeWithTermsAndConditionsValidation: true
			});
		} else {
			this.setState({
				agreeWithTermsAndConditionsValidation: false
			});
			this.props.onConfirm({
				paymentMethod: (!this.props.payment.isFree && this.props.payment.paymentMethod && this.props.payment.paymentMethod.name) ?
					this.props.paymentMethods.find(x => x.name === this.props.payment.paymentMethod.name) : null
			});
		}
	}

	renderBookingDetails() {
		const { paymentType } = this.props;

		switch (paymentType) {
			case PaymentTypes.Lesson:
				return this.renderLessonPaymentDetails();
			case PaymentTypes.IndividualConsultation:
				return this.renderIndividualConsultationDetails();
			case PaymentTypes.Workshop:
				return this.renderWorkshopDetails();
			default:
				return null;
		}
	}

	renderLessonPaymentDetails() {
		const { t, payment, enableUserTimeZone } = this.props;
		const { lesson, child } = payment;
		const { term, center, grade } = lesson;

		const paymentStartDateMoment = moment(payment.startDate);
		let lessonStartDateTime = moment(paymentStartDateMoment.format('YYYY-MM-DDT') + lesson.startTime);
		let lessonEndDateTime = moment(paymentStartDateMoment.format('YYYY-MM-DDT') + lesson.endTime);
		lessonStartDateTime = enableUserTimeZone ? utils.convertToUserTime(lessonStartDateTime, center) : lessonStartDateTime;
		lessonEndDateTime = enableUserTimeZone ? utils.convertToUserTime(lessonEndDateTime, center) : lessonEndDateTime;

		return <div>
			<h3>{t('FO_Booking_Confirm_Class')}</h3>
			<h4><GradeDetailsLink grade={grade} /></h4>
			<p>{term && <span>{term.name} {`(${moment(term.startDate).format('ll')} - ${moment(term.endDate).format('ll')})`}</span>}</p>
			<p><Glyphicon glyph='calendar' /> {lessonStartDateTime.format('ll, dddd')}</p>
			<p><Glyphicon glyph='time' /> {`${lessonStartDateTime.format('LT')} - ${lessonEndDateTime.format('LT')}`}
				{lesson.teacher && lesson.teacher.name ? ` ${t('FO_Booking_Form_WithTeacher')} ` : ''}
				{lesson.teacher && lesson.teacher.name &&
					(lesson.teacher.photoUrl || lesson.teacher.bio ?
						<TeacherDetailsLink teacher={lesson.teacher} /> :
						<b>{lesson.teacher.name}</b>)}
			</p>
			<p><CenterDetailsLink center={center} />{lesson.roomNumber ? `, ${lesson.roomNumber}` : ''}</p>

			<p><Glyphicon glyph='user' /> {child && child.fullName}</p>
		</div>;
	}

	renderIndividualConsultationDetails() {
		const { t, payment: { center, consultationDate, consultationEnd, child }, enableUserTimeZone } = this.props;

		const startDateTime = enableUserTimeZone ? utils.convertToUserTime(consultationDate, center) : moment(consultationDate);
		const endDateTime = enableUserTimeZone ? utils.convertToUserTime(consultationEnd, center) : moment(consultationEnd);

		return <div>
			<h3>{t('FO_Booking_Confirm_Class')}</h3>
			<p><Glyphicon glyph='calendar' /> {startDateTime.format('ll, dddd')}</p>
			<p><Glyphicon glyph='time' /> {`${startDateTime.format('LT')} - ${endDateTime.format('LT')}`}</p>
			<p><CenterDetailsLink center={center} /></p>
			<p><Glyphicon glyph='user' /> {child && child.fullName}</p>
		</div>;
	}

	renderWorkshopDetails() {
		const { t, payment: { center, workshop, workshopSessions, child }, enableUserTimeZone } = this.props;

		const sessionsByWeek = utils.groupBy(workshopSessions, 'weekId');

		return <div>
			<h3>{t('FO_Booking_Confirm_Class')}</h3>
			{workshop && <h4>{workshop.name} <span className='text-muted' style={{ fontSize: '16px' }}>{`(${moment(workshop.startDate).format('ll')} - ${moment(workshop.endDate).format('ll')})`}</span></h4>}

			{/*<p><Glyphicon glyph='calendar' /> {moment(consultationDate).format('ll, dddd')}</p>*/}
			<p><CenterDetailsLink center={center} /></p>
			<p><Glyphicon glyph='user' /> {child && child.fullName}</p>
			{Object.keys(sessionsByWeek).map(weekId => {
				const week = workshop && workshop.weeks.find(x => x.id === Number(weekId));
				const sessions = sessionsByWeek[weekId];

				return week ? <p>
					<Glyphicon glyph='calendar' /> {week.name} <span className='text-muted'>{`(${moment(week.startDate).format('ll')} - ${moment(week.endDate).format('ll')})`}</span>
					<br />
					<table>
						{sessions.map(session => {
							const sessionStart = enableUserTimeZone ? utils.convertToUserTime(session.start, center) : moment(session.start);
							const sessionEnd = enableUserTimeZone ? utils.convertToUserTime(session.end, center) : moment(session.end);

							return <tr>
								<td><span style={{ paddingLeft: 20 }}>{sessionStart.format('ddd, Do')}</span></td>
								<td><span style={{ paddingLeft: 20 }}>{`${sessionStart.format('LT')} - ${sessionEnd.format('LT')}`}</span></td>
							</tr>
						})}
					</table>
				</p> : null;
			})}
		</div>;
	}

	renderPaymentAmounts() {
		const { t, payment, currentCurrency, franchisorCurrency, enableCurrencyConversion } = this.props;
		const conversionLink = ui.getCurrencyConversionLink(enableCurrencyConversion, currentCurrency, franchisorCurrency, payment.totalAmount);

		const hideUnitPrice = payment.hideUnitPrice;

		return <Table>
			<thead>
				<tr>
					<th className='tar'>{t(hideUnitPrice ? 'FO_Payment_Item' : 'FO_Payment_Quantity')}</th>
					{!hideUnitPrice && <th className='tar'>{t('FO_Payment_UnitPrice')}</th>}
					<th className='tar'>{t('FO_Payment_Subtotal')}</th>
				</tr>
			</thead>
			<tbody>
				{(!payment.paymentItems || hideUnitPrice) && <tr>
					<td className='tar'>{hideUnitPrice ? t('FO_Payment_Lessons') : payment.quantity}</td>
					{!hideUnitPrice && <td className='tar'>{payment.unitPrice}</td>}
					<td className='tar'>{payment.subtotal}</td>
				</tr>}
				{payment.paymentItems && payment.paymentItems.map(item => <tr>
					<td className='tar'>{`${item.quantity} x ${item.description}`}</td>
					<td className='tar'>{item.unitPrice}</td>
					<td className='tar'>{item.subtotal}</td>
				</tr>)}
			</tbody>
			<tfoot>
				{payment.discount &&
					<tr style={{ color: 'red' }}>
						<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_Discount')}</th>
						<td className='tar'>{payment.discount}</td>
					</tr>}
				{payment.totalExclTax &&
					<tr>
						<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_TotalExclTax')}</th>
						<td className='tar'>{payment.totalExclTax}</td>
					</tr>}
				{payment.tax &&
					<tr>
						<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_Tax')}</th>
						<td className='tar'>{payment.tax}</td>
					</tr>}
				{payment.paymentMethodFee &&
					<tr>
						<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_PaymentMethodFee')}</th>
						<td className='tar'>{payment.paymentMethodFee}</td>
					</tr>}
				<tr>
					<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_Total')}</th>
					<td className='tar'>{payment.total}
						{conversionLink &&
							<div><a href={conversionLink} target='_blank' className='currency-conversion' >
								{t('FO_Common_ConvertToCurrency', { currency: currentCurrency })}</a></div>}
					</td>
				</tr>
			</tfoot>
		</Table>;
	}

	renderInfoDialog() {
		const body = <div dangerouslySetInnerHTML={{ __html: this.state.infoMessage }} />;
		return <Dialog show={this.state.showInfoDialog} onHide={this.hideInfoDialog} header={this.state.infoTitle} body={body} />;
	}

	renderTermsAndConditionsLabel(i18nKey) {
		const { t } = this.props;
		return <span><Trans i18nKey={i18nKey} parent='span'>
			I agree with the <a style={{ cursor: 'pointer' }} onClick={this.showTermsAndConditions}>{t('FO_Parent_Title')}</a>
		</Trans><em style={{ color: '#D62229' }}>*</em></span>;
	}

	renderPaymentOption(selectedPaymentOption, paymentMethod, isInstalmentPayment, instalmentPlanTemplateId, showManualInstalments) {
		const { t, franchisorCurrency } = this.props;

		const paymentOption = this.getPaymentOptionValue(paymentMethod.name, isInstalmentPayment, instalmentPlanTemplateId);
		const isSelected = selectedPaymentOption === paymentOption;

		const nameResourceKey = `FO_PaymentMethod_${paymentMethod.name}_FriendlyName`;
		const nameResourceKeyWithSuffix = `FO_PaymentMethod_${paymentMethod.name}_FriendlyName_${isInstalmentPayment ? 'Instalment' : franchisorCurrency}`;

		return <Radio key={paymentMethod.name}
			value={paymentOption}
			radioClass='iradio_minimal-grey' increaseArea='20%' labelClassName={isSelected ? 'checked' : ''}
			label={<div><span>{t(i18n.exists(nameResourceKeyWithSuffix) ? nameResourceKeyWithSuffix : nameResourceKey)}</span>
				<Badge className='instant-booking'>{paymentMethod.isInstantPayment ? t('FO_Payment_InstantBooking') : ''}</Badge>
				{isSelected && <CheckoutComponent paymentMethod={paymentMethod} isInstalmentPayment={isInstalmentPayment} payment={this.props.payment} currency={franchisorCurrency} countryCode={this.props.countryCode} showManualInstalments={showManualInstalments}
					onPaymentMethodInit={this.props.onPaymentMethodInit} {...this.props.paymentProcessors[paymentMethod.name]} />}</div>} />;
	}

	getPaymentOptionValue(paymentMethodName, isInstalmentPayment, instalmentPlanTemplateId) {
		return `${paymentMethodName}:${isInstalmentPayment ? 1 : 0}:${instalmentPlanTemplateId || 0}`;
	}

	render() {
		const { t, payment, paymentMethods, instalmentPlans, block, unblock, requireConsentOnPayment, paymentType,
			onApplyPromoCode, onRemovePromoCode, promoCodeErrorMessage, errorMessage, cancellationReason } = this.props;

		if (!payment) {
			return null;
		}

		if (!payment.isNew) {
			return <Alert bsStyle='danger'>{t('FO_Booking_PaymentProcessed')}</Alert>;
		}

		const { paymentMethod, isInstalmentPayment } = payment;
		const selectedPaymentMethodName = paymentMethod && paymentMethod.name;

		const { selectedInstalmentPlanTemplateId, agreeWithTermsAndConditionsValidation } = this.state;

		const selectedPaymentOption = this.getPaymentOptionValue(selectedPaymentMethodName, isInstalmentPayment, selectedInstalmentPlanTemplateId);

		const termsAndConditionsCheckbox = <div className={agreeWithTermsAndConditionsValidation ? 'has-error' : ''}>
			<Checkbox
				label={this.renderTermsAndConditionsLabel('FO_Register_TermsAndConditions')}
				onChange={this.toggleTermsAndConditions}
				checkboxClass='icheckbox_minimal-grey' increaseArea='20%'
			/>
			{agreeWithTermsAndConditionsValidation && <HelpBlock>{t('FO_Register_AgreeWithTermsAndConditionsRequired')}</HelpBlock>}
		</div>;

		const infoDialog = this.renderInfoDialog();
		const showInstalmentPaymentMethods = paymentMethods.some(x => x.supportsRecurringPayments) && payment.allowInstalmentPayment;

		return <div>
			<div className='steps_title'>{t('FO_Booking_Confirm_Title')}</div>
			<ReduxBlockUi block={block} unblock={unblock}>
				<Row>
					<Col sm={8}>
						<div className='checkout-container'>
							{cancellationReason && <div className='checkout-section'>
								<Alert bsStyle='danger'>
									<Trans i18nKey='FO_Booking_PaymentCancelledReason'>
										<p>Payment is not completed: <b>{{ cancellationReason }}</b></p>
										<p>Please select a payment method and try again.</p>
									</Trans>
								</Alert>
							</div>}
							{payment.isFree ? <div className='checkout-section'>{t('FO_Payment_NotRequired')}</div> :
								<div className='checkout-section payment-methods'>
									{showInstalmentPaymentMethods && <h3>{t('FO_Payment_OnetimePayment')}</h3>}
									<RadioGroup name='paymentMethod' value={selectedPaymentOption} onChange={(event) => this.handlePaymentMethodChange(event)}>
										{paymentMethods.filter(p => p.supportsOneOffPayments).map(p => this.renderPaymentOption(selectedPaymentOption, p, false, null, paymentType === PaymentTypes.Lesson))}
									</RadioGroup>
								</div>}
							{!payment.isFree && showInstalmentPaymentMethods && instalmentPlans && instalmentPlans.map(instalmentPlan => {
								const recurrenceDisplayName = instalmentPlan.intervalLength === 1 ? t(`RecurrenceType_${instalmentPlan.intervalType.name}`) : '';

								const instalmentPlanIntervalDescription = instalmentPlan.intervalLength > 1 && instalmentPlan.totalIntervals > 1 ? t('FO_Payment_InstalmentIntervalDescription', { intervalLength: instalmentPlan.intervalLength, intervalType: t(`FO_Payment_InstalmentIntervalType_${instalmentPlan.intervalType.name}`) }) : '';
								const instalmentPlanDownPaymentDescription = instalmentPlan.downPaymentAmount > 0 ? t('FO_Payment_InstalmentDepositDescription', { amount: instalmentPlan.downPayment }) : '';
								const instalmentPlanInstalmentDescripton = t('FO_Payment_InstalmentDescription', { count: instalmentPlan.totalIntervals, recurrence: `${recurrenceDisplayName} `, amount: instalmentPlan.instalment, startDate: moment(instalmentPlan.startDate).format('l') });
								const instalmentPlanStartDescription = instalmentPlan.totalIntervals > 1 ? t('FO_Payment_InstalmentStartDescription', { startDate: moment(instalmentPlan.startDate).format('l') }) : '';

								const instalmentPlanDescription = `${instalmentPlanDownPaymentDescription} ${instalmentPlanInstalmentDescripton} ${instalmentPlanIntervalDescription} ${instalmentPlanStartDescription}`;
								const instalmentPlanFriendlyname = t('FO_Payment_InstalmentPlanFriendlyName', { count: instalmentPlan.totalIntervals + (instalmentPlan.downPayments > 0 ? 1 : 0) });
								return <div className='checkout-section payment-methods'>
									<h3>{instalmentPlanFriendlyname}</h3>
									<h3 style={{ textTransform: 'lowercase' }}>{instalmentPlanDescription}</h3>
									<RadioGroup name='paymentMethod' value={selectedPaymentOption} onChange={(event) => this.handlePaymentMethodChange(event)}>
										{paymentMethods.filter(p => p.supportsRecurringPayments).map(p => this.renderPaymentOption(selectedPaymentOption, p, true, instalmentPlan.templateId, false))}
									</RadioGroup>
								</div>;
							})}
							{requireConsentOnPayment && <div className='checkout-section' style={{ marginTop: '10px' }}>
								{termsAndConditionsCheckbox}
							</div>}
							<div className='checkout-section'>
								<PromoCodes appliedPromoCodes={payment.promoCodes} onApply={onApplyPromoCode} onRemove={onRemovePromoCode} errorMessage={promoCodeErrorMessage} />
							</div>
							<div className='checkout-section'>
								{errorMessage && <Alert bsStyle='danger'>{errorMessage}</Alert>}
								<Button bsStyle='primary' disabled={!payment.isFree && (!selectedPaymentMethodName || (payment.isInstalmentPayment && !selectedInstalmentPlanTemplateId))} onClick={this.handleConfirmClick} className='pull-right btn-block-xxs'>{t('FO_Booking_Confirm')} <FontAwesome name='arrow-circle-right' /></Button>
								<Link to='../class' className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('Common_Back')}</Link>
								<div className='clearfix' />
							</div>
						</div>
					</Col>
					<Col sm={4}>
						<div className='booking-options-container' style={{ width: '100%', minHeight: 'auto', marginBottom: '10px', marginLeft: '0' }}>
							{this.renderBookingDetails()}
						</div>
						<div className='booking-options-container' style={{ width: '100%', minHeight: 'auto', marginLeft: '0' }}>
							<h3>{t('FO_Booking_Confirm_PriceBreakdown')}</h3>
							<h4>{payment.description}</h4>
							{this.renderPaymentAmounts()}
						</div>
					</Col>
				</Row>
				{infoDialog}
			</ReduxBlockUi>
		</div>;
	}
}

Confirm.propTypes = {
	onPaymentMethodInit: PropTypes.func.isRequired,
	onSelectPaymentMethod: PropTypes.func.isRequired,
	onApplyPromoCode: PropTypes.func.isRequired,
	onRemovePromoCode: PropTypes.func.isRequired,
	promoCodeErrorMessage: PropTypes.string,
	cancellationReason: PropTypes.string,
	onConfirm: PropTypes.func.isRequired,
	errorMessage: PropTypes.string,
	paymentType: PropTypes.oneOf([PaymentTypes.Lesson, PaymentTypes.IndividualConsultation, PaymentTypes.Workshop]),
	termsAndConditions: PropTypes.string,
	paymentMethods: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		friendlyName: PropTypes.string,
		description: PropTypes.string,
		configuration: PropTypes.object
	})),
	instalmentPlans: PropTypes.arrayOf(PropTypes.shape({
		templateId: PropTypes.number,
		intervalLength: PropTypes.number,
		intervalType: PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string
		}),
		downPayment: PropTypes.string,
		downPaymentAmount: PropTypes.number,
		totalIntervals: PropTypes.number,
		instalment: PropTypes.string
	})),
	payment: PropTypes.oneOfType([
		PropTypes.shape({
			id: PropTypes.number,
			startDate: PropTypes.string,
			lesson: PropTypes.shape({
				startTime: PropTypes.string,
				endTime: PropTypes.string,
				term: PropTypes.shape({
					name: PropTypes.string,
					startDate: PropTypes.string,
					endDate: PropTypes.string,
					schoolYear: PropTypes.string
				}),
				center: PropTypes.shape(
					{
						name: PropTypes.string
					}),
				grade: PropTypes.shape({
					id: PropTypes.number,
					name: PropTypes.string
				})
			}),
			quantity: PropTypes.number,
			unitPrice: PropTypes.string,
			unitPriceAmount: PropTypes.number,
			subtotal: PropTypes.string,
			total: PropTypes.string,
			description: PropTypes.string,
			paymentMethod: PropTypes.shape({
				friendlyName: PropTypes.string
			}),
			status: PropTypes.string,
			child: PropTypes.shape({
				fullName: PropTypes.string
			})
		}),
		PropTypes.shape({
			id: PropTypes.number,
			center: PropTypes.shape(
				{
					name: PropTypes.string
				}),
			consultationDate: PropTypes.string,
			consultationEnd: PropTypes.string,
			consultationType: PropTypes.string,
			quantity: PropTypes.number,
			unitPrice: PropTypes.string,
			subtotal: PropTypes.string,
			total: PropTypes.string,
			description: PropTypes.string,
			paymentMethod: PropTypes.shape({
				friendlyName: PropTypes.string
			}),
			status: PropTypes.string,
			child: PropTypes.shape({
				fullName: PropTypes.string
			})
		})
	])
};

export default withNamespaces()(Confirm);